import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import moment from "moment";
import { Space } from "@masterteam/mt-design-react";

import { ReactComponent as ArrowIcon } from "../../../../assets/images/down-arrow.svg";

import "./style.scss";

function Item({ data = {} }) {
  const [expanded, setExpanded] = useState(false);
  const themeColor = useSelector((store) => store.theme.primary);
  const intl = useIntl();

  function toggleExpand() {
    setExpanded(!expanded);
  }

  function getTitle() {
    let res = "";

    switch (data?.Frequency) {
      case "quarterly": {
        res = `Q${Math.ceil(
          +moment(data?.DueDate).locale("en").quarter()
        )}-${moment(data?.DueDate).locale("en").format("YYYY")}`;
        break;
      }

      case "monthly": {
        res = `${moment(data?.DueDate).locale("en").format("MMM, YYYY")}`;
        break;
      }

      case "semi-annual": {
        res = `H${Math.ceil(
          +moment(data?.DueDate).locale("en").format("MM") / 6
        )}-${moment(data?.DueDate).locale("en").format("YYYY")}`;
        break;
      }

      case "annual": {
        res = `${moment(data?.DueDate).locale("en").format("YYYY")}`;
        break;
      }

      default:
        break;
    }

    return res;
  }

  return (
    <Space className="historical-info__item" gap={0} direction="vertical">
      <Space
        className="historical-info__item__header"
        onClick={toggleExpand}
        style={{ backgroundColor: themeColor }}
        align="center"
      >
        <Space>{getTitle()}</Space>
        <Space>
          <ArrowIcon
            height={16}
            width={16}
            fill="#FFF"
            style={{ transform: expanded ? "rotate(180deg)" : undefined }}
          />
        </Space>
      </Space>
      {expanded ? (
        <Space className="historical-info__item__content" direction="vertical">
          <Space className="historical-info__item__content__percentages">
            <Space
              className="historical-info__item__content__percentages__percentage"
              style={{ backgroundColor: themeColor }}
            >
              {`${intl.formatMessage({ id: "kpi-history.value" })}: ${
                data?.Value || 0
              }%`}
            </Space>
            <Space
              className="historical-info__item__content__percentages__percentage"
              style={{ backgroundColor: themeColor }}
            >
              {`${intl.formatMessage({
                id: "kpi-history.target",
              })}: ${data?.Target || 0}%`}
            </Space>
          </Space>
          <Space
            className="historical-info__item__content__textareas"
            direction="vertical"
          >
            <Space
              className="historical-info__item__content__textareas__textarea"
              direction="vertical"
            >
              <label>
                <FormattedMessage id="kpi-details.justifcations" />
              </label>
              <Space className="historical-info__item__content__textareas__textarea__text">
                {data?.Justification}
              </Space>
            </Space>
            <Space
              className="historical-info__item__content__textareas__textarea"
              direction="vertical"
            >
              <label>
                <FormattedMessage id="kpi-details.corrective-action" />
              </label>
              <Space className="historical-info__item__content__textareas__textarea__text">
                {data?.CorrectiveAction}
              </Space>
            </Space>
            <Space
              className="historical-info__item__content__textareas__textarea"
              direction="vertical"
            >
              <label>
                <FormattedMessage id="kpi-details.more-information" />
              </label>
              <Space className="historical-info__item__content__textareas__textarea__text">
                {data?.MoreInformation}
              </Space>
            </Space>
          </Space>
        </Space>
      ) : null}
    </Space>
  );
}

export default Item;
